var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 -5 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_23.Videos",
    "data-name": "23.Videos",
    d: "M43,42H5a4,4,0,0,1-4-4V10A4,4,0,0,1,5,6H43a4,4,0,0,1,4,4V38A4,4,0,0,1,43,42ZM12,8H5a2,2,0,0,0-2,2v2h9ZM23,8H14v4h9ZM34,8H25v4h9Zm11,2a2,2,0,0,0-2-2H36v4h9Zm0,4H3V34H45Zm0,22H36v4H34V36H25v4H23V36H14v4H12V36H3v2a2,2,0,0,0,2,2H43a2,2,0,0,0,2-2ZM21.621,29.765A.987.987,0,0,1,21,30a1,1,0,0,1-1-1V19a1,1,0,0,1,1-1,.978.978,0,0,1,.563.2l7.771,4.872a.974.974,0,0,1,.261,1.715Z",
    transform: "translate(-1 -6)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.4dc578889fbe08d210c27ee7acae9123.svg";
export { ForwardRef as ReactComponent };